import { useEffect, useRef } from "react";
import SwaggerUIBundle from "swagger-ui-dist/swagger-ui-bundle.js";
import "swagger-ui-dist/swagger-ui.css";

const ApiDocs = ({ url }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const ui = SwaggerUIBundle({
      url: url,
      domNode: containerRef.current,
      presets: [
        SwaggerUIBundle.presets.apis,
        SwaggerUIBundle.SwaggerUIStandalonePreset,
      ],
      layout: "BaseLayout",
    });

    return () => {
      ui?.getSystem?.()?.getStore?.()?.destroy?.();
    };
  }, []);

  return <div ref={containerRef} />;
};

export default ApiDocs;
